export function normalizePercent(value) {
	const percentAsNumber = Number(String(value ?? 0).replace(",", "."));
	if (Number.isNaN(percentAsNumber)) {
		return 0;
	}
	return Math.max(0, percentAsNumber);
}
